/*
export function someGetter (state) {
}
*/